module.exports = __webpack_public_path__ + "static/media/stanne.287e8a51.webp";